import { BoxContent, Heading, Link } from '@mm/components';
import { formattedInvoicesSelector } from '@mm/state/selectors/subscriptionSelectors';
import { activeChatbotSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { ReactComponent as ThankYouPageIcon } from 'assets/thank-you-page.svg';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PrimaryButton } from '../../../common/buttons/PrimaryButton/PrimaryButton';
import { CHATBOT_EDITOR } from '../../../common/constants/routes';
import { BotBuilderRoutes } from '../../../routes/bot-builder-routes';
import styles from './ThankYouPage.module.css';

export const ThankYouPage = () => {
  const history = useHistory();
  const invoices = useSelector(formattedInvoicesSelector);
  const chatbot = useSelector(activeChatbotSelector);
  const chatbotId = useSelector(
    (state: StoreState) => state.chatbot.basicListByCompany[0]?.id,
  );

  return (
    <BoxContent className={styles.container}>
      <ThankYouPageIcon />
      <div className={styles.description}>
        <Heading size={3}>Thank you for subscribing!</Heading>
        {invoices[0]?.invoiceLink && (
          <Link href={invoices[0]?.invoiceLink} isBlank>
            View Receipt
          </Link>
        )}
        <div className={styles.text}>
          Your account executive will provide a link to schedule a call with our
          onboarding team as soon as we have assigned a customer success manager
          to your account
        </div>
        <PrimaryButton
          onClick={() => {
            if (chatbot?.id) {
              history.push(
                BotBuilderRoutes.dashboard.getLink({
                  chatbotId: chatbot.id || chatbotId,
                }),
              );
            } else {
              history.push(CHATBOT_EDITOR);
            }
          }}
        >
          Go to Dashboard
        </PrimaryButton>
      </div>
    </BoxContent>
  );
};
